import { AxiosInstance } from 'axios'
import { axiosInstance as v1Axios } from 'src/utils/request'
import { axiosInstance as v2Axios } from 'src/utils/requestV2'

export interface ApiClient {
  get<T>(url: string, params?: Record<string, any>): Promise<T>
  post<T>(url: string, data?: unknown, params?: Record<string, any>): Promise<T>
  put<T>(url: string, data?: unknown, params?: Record<string, any>): Promise<T>
  patch<T>(
    url: string,
    data?: unknown,
    params?: Record<string, any>,
  ): Promise<T>
  del<T>(
    url: string,
    config?: { params?: Record<string, any>; data?: unknown },
  ): Promise<T>
}

// Takes a getter (not the instance itself) so the underlying axios instance
// is only read on first actual use, not at module-evaluation time. request.ts
// and requestV2.ts both import src/router, which transitively imports this
// module back (see e.g. service/configNode.ts, service/rotessaStakeholders.ts) —
// reading v1Axios/v2Axios eagerly here can hit that cycle mid-initialization
// and throw "Cannot access 'v1Axios' before initialization".
function wrapAxios(getInstance: () => AxiosInstance): ApiClient {
  return {
    get: async <T>(url: string, params?: Record<string, any>) => {
      const res = await getInstance().get<T>(url, { params })
      return res.data
    },
    post: async <T>(
      url: string,
      data?: unknown,
      params?: Record<string, any>,
    ) => {
      const res = await getInstance().post<T>(url, data, { params })
      return res.data
    },
    put: async <T>(
      url: string,
      data?: unknown,
      params?: Record<string, any>,
    ) => {
      const res = await getInstance().put<T>(url, data, { params })
      return res.data
    },
    patch: async <T>(
      url: string,
      data?: unknown,
      params?: Record<string, any>,
    ) => {
      const res = await getInstance().patch<T>(url, data, { params })
      return res.data
    },
    del: async <T>(
      url: string,
      config?: { params?: Record<string, any>; data?: unknown },
    ) => {
      const res = await getInstance().delete<T>(url, config)
      return res.data
    },
  }
}

export const v1Client = wrapAxios(() => v1Axios)
export const v2Client = wrapAxios(() => v2Axios)
